import React, { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { Box, Text } from "@chakra-ui/react";
import { useSelector } from "react-redux";
import useComingSoonToast from "../../hooks/useComingSoonToast";
import { BiFootball } from "react-icons/bi";
import { MdSportsCricket, MdSportsTennis } from "react-icons/md";
import {
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon,
} from "@chakra-ui/react";
import { FaHorse, FaRegPlusSquare, FaRegMinusSquare } from "react-icons/fa";
import { sidebarCasinoList } from "../../utils/constants";

const AllSportsLinkItems = [
  { name: "cricket", icon: MdSportsCricket, isMap: true, nonStatic: true },
  { name: "soccer", icon: BiFootball, isMap: true, nonStatic: true },
  { name: "tennis", icon: MdSportsTennis, isMap: true, nonStatic: true },
  { name: "tableTennis", icon: MdSportsTennis, isMap: false, noOfGames: 2 },
  { name: "basketball", icon: MdSportsCricket, isMap: false, noOfGames: 6 },
  { name: "volleyball", icon: MdSportsCricket, isMap: false, noOfGames: 2 },
  { name: "snooker", icon: MdSportsCricket, isMap: false, noOfGames: 7 },
  { name: "handball", icon: MdSportsCricket, isMap: false, noOfGames: 8 },
  { name: "iceHockey", icon: MdSportsCricket, isMap: false, noOfGames: 3 },
  { name: "eGames", icon: MdSportsCricket, isMap: false, noOfGames: 6 },
  { name: "futsal", icon: MdSportsCricket, isMap: false, noOfGames: 5 },
  { name: "kabaddi", icon: MdSportsCricket, isMap: false, noOfGames: 8 },
  { name: "golf", icon: MdSportsCricket, isMap: false, noOfGames: 10 },
  { name: "rugbyLeague", icon: MdSportsCricket, isMap: false, noOfGames: 2 },
  { name: "boxing", icon: MdSportsCricket, isMap: false, noOfGames: 7 },
];

const RacingLinkItems = [
  { name: "Horse Racing", icon: FaHorse, link: "/horse-racing" },
  { name: "Greyhound Racing", icon: FaHorse, link: "/greyhound-racing" },
];

const formatSportName = (name) => {
  if (name === "soccer") return "Football";
  if (name === "eGames") return "E-Games";
  return name
    .replace(/([A-Z])/g, " $1")
    .replace(/^./, (str) => str.toUpperCase());
};

const groupByLeague = (matches) => {
  if (!Array.isArray(matches) || matches.length === 0) return {};
  const grouped = {};
  let currentGroup = "Other";
  matches.forEach((match) => {
    if (match.marketId === "0" || match.marketId === 0) {
      currentGroup = match.eventName.trim();
      if (!grouped[currentGroup]) grouped[currentGroup] = [];
    } else {
      if (!grouped[currentGroup]) grouped[currentGroup] = [];
      grouped[currentGroup].push(match);
    }
  });
  return grouped;
};

const groupFlat = (matches, label) => {
  if (!Array.isArray(matches) || matches.length === 0) return {};
  return { [label]: matches };
};

const Sidebar = ({ onClose, isSidebarOpen, setIsSidebarOpen }) => {
  const naviagte = useNavigate();
  const showComingSoon = useComingSoonToast();

  const cricketGames = useSelector((state) => state?.gameData?.cricketGames);
  const soccerGames = useSelector((state) => state?.gameData?.soccerGames);
  const tennisGames = useSelector((state) => state?.gameData?.tennisGames);

  const gameData = useMemo(() => ({
    cricket: groupByLeague(cricketGames),
    soccer: groupFlat(soccerGames, "Football Matches"),
    tennis: groupFlat(tennisGames, "Tennis Matches"),
  }), [cricketGames, soccerGames, tennisGames]);

  const navigateToGame = (id, gameEvent) => {
    setIsSidebarOpen(false);
    naviagte(`/game/${id}/${gameEvent[id + "Id"]}`, {
      state: {
        gameEvent: {
          ...gameEvent,
          eventTime: gameEvent.eventDate
            ? gameEvent.eventDate
            : gameEvent.eventTime
            ? gameEvent.eventTime
            : gameEvent.startDate,
        },
      },
    });
  };
  return (
    <div className={`sidebar ${isSidebarOpen ? "open" : ""}`}>
      <Accordion defaultIndex={[0]} allowToggle>
        <AccordionItem>
          <AccordionButton
            className="sidebar-heading"
            aria-controls="racing"
            aria-expanded="true"
            role="button"
          >
            <Box fontSize="sm" as="span" flex="1" textAlign="left">
              Racing Sports
            </Box>
            <AccordionIcon />
          </AccordionButton>

          <AccordionPanel p={0}>
            <nav className="collapse casino show">
              <ul>
                {RacingLinkItems.map((item) => (
                  <li key={item.name} className="nav-item">
                    <a
                      className="nav-link"
                      style={{ cursor: "pointer" }}
                      onClick={(e) => {
                        e.preventDefault();
                        showComingSoon(item.name);
                      }}
                    >
                      <span className="new-launch-text">{item.name}</span>
                    </a>
                  </li>
                ))}
              </ul>
            </nav>
          </AccordionPanel>
        </AccordionItem>
      </Accordion>

      <Accordion defaultIndex={[0]} allowToggle>
        <AccordionItem>
          <AccordionButton
            className="sidebar-heading"
            aria-controls="events"
            aria-expanded="true"
            role="button"
          >
            <Box fontSize="sm" as="span" flex="1" textAlign="left">
              Others
            </Box>
            <AccordionIcon />
          </AccordionButton>

          <AccordionPanel p={0}>
            <nav className="collapse casino show">
              <ul>
                {sidebarCasinoList.map((game) => (
                  <li key={game.name} className="nav-item">
                    <a
                      className="nav-link"
                      style={{ cursor: "pointer" }}
                      onClick={(e) => {
                        e.preventDefault();
                        if (game.pending) {
                          showComingSoon(game.name);
                        } else {
                          setIsSidebarOpen(false);
                          naviagte(game.link);
                        }
                      }}
                    >
                      <span className={`new-launch-text${game.blink ? " sidebar-blink" : ""}`}>{game.name}</span>
                    </a>
                  </li>
                ))}
              </ul>
            </nav>
          </AccordionPanel>
        </AccordionItem>
      </Accordion>

      <Accordion defaultIndex={[0]} allowToggle>
        <AccordionItem>
          <AccordionButton
            className="sidebar-heading"
            aria-controls="events"
            aria-expanded="true"
            role="button"
          >
            <Box fontSize="sm" as="span" flex="1" textAlign="left">
              All Sports
            </Box>
            <AccordionIcon />
          </AccordionButton>

          <AccordionPanel pb={4}>
            <Box className="menu_box">
              <Accordion p="0" allowToggle>
                {AllSportsLinkItems.map((link) =>
                  link.pending ? (
                    <Box key={link.name} p="0" borderTop="1px solid" borderBottom="1px solid" borderColor="inherit">
                      <button
                        type="button"
                        className="chakra-accordion__button inner-accordion"
                        style={{ padding: 0, width: "100%", display: "flex", alignItems: "center", background: "none", border: "none", cursor: "pointer" }}
                        onClick={() => showComingSoon(formatSportName(link.name))}
                      >
                        <FaRegPlusSquare size={14} color="var(--text-dark)" />
                        <Text
                          ml="2"
                          fontSize="14px"
                          color="var(--text-body)"
                          flex="1"
                          textAlign="left"
                        >
                          {formatSportName(link.name)}
                        </Text>
                      </button>
                    </Box>
                  ) : (
                  <AccordionItem p="0" key={link.name}>
                    {({ isExpanded }) => (
                      <>
                        <AccordionButton
                          p="0"
                          className="inner-accordion"
                          onClick={(e) => {
                            if (!link.nonStatic) {
                              e.preventDefault();
                              e.stopPropagation();
                              showComingSoon(formatSportName(link.name));
                            }
                          }}
                        >
                          {isExpanded
                            ? <FaRegMinusSquare size={14} color="var(--text-dark)" />
                            : <FaRegPlusSquare size={14} color="var(--text-dark)" />}
                          <Text
                            ml="2"
                            fontSize="14px"
                            color="var(--text-body)"
                            flex="1"
                            textAlign="left"
                          >
                            {formatSportName(link.name)}
                          </Text>
                        </AccordionButton>

                        {link.nonStatic && gameData[link.name] && (
                          <AccordionPanel p="0" border="none">
                            <Accordion p="0" allowToggle border="none" pl={4}>
                              {link.isMap
                                ? Object.keys(gameData[link.name]).map((gameName) => (
                                    <AccordionItem key={gameName}>
                                      {({ isExpanded: isSubExpanded }) => (
                                        <>
                                          <AccordionButton
                                            p="0.5"
                                            className="inner-accordion"
                                          >
                                            {isSubExpanded
                                              ? <FaRegMinusSquare size={13} color="var(--text-dark)" />
                                              : <FaRegPlusSquare size={13} color="var(--text-dark)" />}
                                            <Text
                                              ml="2"
                                              flex="1"
                                              fontSize="13px"
                                              color="var(--text-body)"
                                              textAlign="left"
                                            >
                                              {gameName}
                                            </Text>
                                          </AccordionButton>
                                          <AccordionPanel p="1" pl="6" mt="1" border="none">
                                            {gameData[link.name][gameName].map(
                                              (match) => (
                                                <Box
                                                  key={match.eventName}
                                                  cursor="pointer"
                                                  borderBottom="1px solid var(--border-color, #ddd)"
                                                  onClick={() =>
                                                    navigateToGame(link.name, match)
                                                  }
                                                >
                                                  <Text
                                                    flex="1"
                                                    color="var(--text-body)"
                                                    textAlign="left"
                                                    mt="1"
                                                    fontSize="13px"
                                                  >
                                                    {match.eventName}
                                                  </Text>
                                                </Box>
                                              )
                                            )}
                                          </AccordionPanel>
                                        </>
                                      )}
                                    </AccordionItem>
                                  ))
                                : gameData[link.name].map((event) => (
                                    <AccordionItem p="1" key={event.eventName}>
                                      <Text
                                        flex="1"
                                        cursor="pointer"
                                        color="var(--text-body)"
                                        textAlign="left"
                                        mt="1"
                                        fontSize="13px"
                                        onClick={() =>
                                          navigateToGame(link.name, event)
                                        }
                                      >
                                        {event.eventName}
                                      </Text>
                                    </AccordionItem>
                                  ))}
                            </Accordion>
                          </AccordionPanel>
                        )}
                      </>
                    )}
                  </AccordionItem>
                  )
                )}
              </Accordion>
            </Box>
          </AccordionPanel>
        </AccordionItem>
      </Accordion>
    </div>
  );
};

export default Sidebar;
